import { useState, useEffect } from "react";
import { useMoralis } from 'react-moralis';
import { Navigate, Link } from 'react-router-dom';
import { SecondaryNavigation } from '../../components/SecondaryNavigation/secondarynav';
import './minting.css';
import loader from '../../loading.png';
//import abi_erc721 from '../../contracts/abi_ERC721.json';
import abi_minter from '../../contracts/abi_OpenMinter.json';

export const Minting = () => {
    const { isAuthenticated, Moralis, enableWeb3, isWeb3Enabled } = useMoralis();
    const currentUser = isAuthenticated ? Moralis.User.current() : undefined;
    const [isUserWhitelisted, setIsUserWhitelisted] = useState(false);
    const [amountToMint, setAmountToMint] = useState(1);
    const [mintOn, setMintOn] = useState(false);
    const [nftPrice, setNftPrice] = useState();
    const [mintSuccess, setMintSuccess] = useState(false);
    const [mintTxHash, setMintTxHash] = useState(false);
    const [mintError, setMintError] = useState(false);
    const [mintErrorMsg, setMintErrorMsg] = useState(false);
    const [ chainId, setChainId ] = useState('');
    //Config for minting
    const whitelistActive = false;
    const minterContractAddress = "0xd499F6bD8C6cB898F8EecF03366640f8c5639a29";
    //const rubyContractAddress = "0xd34D63Fd29AA2363Bad53301Dc68D97eF28E43cd";
    const contractChainId = "0x4";

    useEffect(()=>{
        if(isWeb3Enabled){
            //get the price
            const options = {
                contractAddress: minterContractAddress,
                functionName: 'getMintCost',
                abi: abi_minter,
                params: {
                    "amountOfTokensToBuy": 1
                }
            };
            Moralis.executeFunction(options).then((r) =>{
                let price = parseInt(r._hex, 16) * 1.01;
                setNftPrice(price);
            });  
        }
    },[Moralis, isWeb3Enabled])

    useEffect(()=>{
        if(!isAuthenticated) return <Navigate to="/login"/>;
        if(!isWeb3Enabled) enableWeb3();
        setChainId(Moralis.getChainId());
    // eslint-disable-next-line
    },[isAuthenticated, enableWeb3,isWeb3Enabled,chainId])

    useEffect(()=>{
        if(currentUser?.attributes.whitelisted) setIsUserWhitelisted(currentUser?.attributes.whitelisted);
    // eslint-disable-next-line
    },[])

    const subAmount = (e) => {
        e.preventDefault();
        if(amountToMint > 1) setAmountToMint(amountToMint-1);
    }
    const addAmount = (e) => {
        e.preventDefault();
        if(amountToMint < 10) setAmountToMint(amountToMint+1);
    }

    const mint = async () => {
        if(isWeb3Enabled){
            setMintOn(true);
            setMintError(false);
            setMintSuccess(false);
            try{
                const options = {
                    contractAddress: minterContractAddress,
                    functionName: "batchMint",
                    abi: abi_minter,
                    params: {
                        "proof":[],
                        "amount": amountToMint
                    },
                    msgValue: nftPrice * amountToMint
                };
                //send the transaction
                const tx = await Moralis.executeFunction(options);
                setMintTxHash(tx.hash);
                await tx.wait().then((res)=>{
                    console.log(res);
                    setMintOn(false);
                    setMintSuccess(true);
                });            
            }catch(error){
                setMintOn(false);
                setMintError(true);
                if(error.code === 4001){
                    setMintErrorMsg("User rejected the transaction.")
                }else{
                    setMintErrorMsg(error.code)
                }
                ;
            }
        }else{
            await enableWeb3();
            mint();
            return;
        }
    }

    const renderMintOptions = () => {
        if(isAuthenticated && nftPrice!==""){
            if(whitelistActive){
                if(isUserWhitelisted){
                    return  <>
                            { mintSuccess && <div className="mint-success">
                                    <p><svg aria-hidden="true" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" style={{marginRight:"10px"}}><path fill="#ffffff" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>Mint successful!</p>
                                    <small>You can check your transaction <a href={`https://etherscan.io/tx/${mintTxHash}`} title="View Transaction" rel="noreferrer" target="_blank">HERE.</a></small>
                                </div>
                            }
                            { mintError && <div className="mint-error"><strong>Error</strong>: {mintErrorMsg}</div>}
                            { mintOn || <>
                                <p>MINT YOUR RUBYROCK<br/>
                                1 RUBYROCK = 1250 RBY = 0.125 Carats = $1000</p>
                                <p>How many would you like to mint?</p>
                                <div className="asset-amount-container">
                                    <button className="change-amount-button" onClick={(e)=>subAmount(e)}>-</button>
                                    <input className="asset-amount" type="number" min="1" max="10" value={amountToMint} onChange={(e)=>setAmountToMint(e.target.value)}/>
                                    <button className="change-amount-button" onClick={(e)=>addAmount(e)}>+</button>
                                </div>
                                </>
                            }
                            { mintOn && <>
                                <div className="loading-spinner"><img src={loader} alt="loading..."/></div>
                            </>}
                                <button
                                    className='btn btn-custom btn-large mint-button'
                                    onClick={mint}
                                    disabled={mintOn || chainId!==contractChainId || nftPrice==="" ? true : false}
                                    >
                                    {mintOn ? "Minting..." : "Mint"}
                                </button>
                            </>
                }else{
                    return <p>You are not on the Whitelist, please go to the<br/><Link to="/whitelist">Whitelist Registration page</Link></p>
                }
            }else{
                return  <>
                        { mintSuccess && <div className="mint-success">
                                <p style={{padding: "10px", marginBottom: "0"}}><svg aria-hidden="true" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" style={{marginRight:"10px"}}><path fill="#ffffff" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>Mint successful!</p>
                                <small>You can check your transaction <a href={`https://etherscan.io/tx/${mintTxHash}`} title="View Transaction" rel="noreferrer" target="_blank">HERE.</a></small>
                            </div>
                        }
                        { mintError && <div className="mint-error"><strong>Error</strong>: {mintErrorMsg}</div>}
                        { mintOn || <>
                            <p>MINT YOUR RUBYROCK<br/>
                            <span className="mint-formula">1 RUBYROCK = 1250 RBY = 0.125 Carats = $1000</span></p>
                            <div className="asset-amount-container">
                                <button className="change-amount-button" onClick={(e)=>subAmount(e)}>-</button>
                                <input className="asset-amount" type="number" min="1" max="10" value={amountToMint} onChange={(e)=>setAmountToMint(e.target.value)}/>
                                <button className="change-amount-button" onClick={(e)=>addAmount(e)}>+</button>
                            </div>
                            </>
                        }
                        { mintOn && <p>After you approve the transaction in your wallet, it might take a few minutes for the transaction to be confirmed.<br/>Please wait and don't refresh the page.</p>}
                            <button
                                className='btn btn-custom btn-large mint-button'
                                onClick={mint}
                                disabled={mintOn || chainId!==contractChainId || nftPrice==="" ? true : false}
                                >
                                {mintOn ? "Minting..." : "Mint"}
                            </button>
                        </>
            }
        }else{
            return <div className='wrong-network'>Fetching NFT price...</div>
        }
    }

    return (
        <>
        <SecondaryNavigation />
        {!isAuthenticated && <Navigate to="/login" replace/>}
        { chainId===contractChainId || 
            <div className='wrong-network'>Please connect your wallet to the Ethereum Network</div>
        }
        <div id="mint" className='text-center'>
            <div className='container'>
                <div className='section-title'>
                    <h2>Mint</h2>
                    { renderMintOptions() }
                </div>
            </div>
        </div>
        </>
    )
}